/**
 * Shared `[!TYPE]` callout convention used by both the markdown path
 * (markdownCallouts.js -> remarkCallouts, operating on mdast blockquotes)
 * and the HTML path (htmlCallouts.js -> rehypeCallouts, operating on hast
 * <blockquote> elements from backend-authored lesson HTML).
 *
 * A blockquote whose first line of text is `[!TYPE]` gets converted into a
 * styled callout, matching the mockup's definition / worked-example /
 * key-concept / warning / tip treatments. This is a pure frontend
 * convention layered on top of plain, valid blockquote syntax — no backend
 * changes are required for it to work, and any existing lesson content
 * (which can't already contain this exact bracket marker) renders exactly
 * as it did before.
 *
 *   > [!DEFINITION]
 *   > Span. The span of a set of vectors is the collection of every vector
 *   > that can be written as a linear combination of them.
 */
export const CALLOUT_TYPES = {
  DEFINITION: { className: 'callout-definition', label: 'Definition' },
  EXAMPLE: { className: 'callout-worked-example', label: 'Worked example' },
  WARNING: { className: 'warning', label: 'Warning' },
  TIP: { className: 'tip', label: 'Tip' },
  NOTE: { className: 'callout-key-concept', label: 'Key concept' },
  KEY: { className: 'callout-key-concept', label: 'Key concept' },
};

export const CALLOUT_MARKER = /^\s*\[!([A-Z]+)\]\s*\n?/;
